import type { MeasurementStrategyContext, PdpMeasurementStrategy } from './PdpMeasurementStrategy';
import { bindSectionReachedObserver } from './sectionReachedObserver';

const RECOMMENDATION_SECTION_SELECTORS: readonly string[] = [
  '.product-cross-selling',
  '[data-cross-selling]',
  '.product-detail-cross-selling',
];

/**
 * Cross-selling / recommendations visibility: same late-binding pattern as reviews, with a small set of
 * selectors for native `.product-cross-selling` plus common theme hooks—extend the list when shops differ.
 *
 * Plugin coverage: partial — native Shopware cross-selling (`.product-cross-selling`) and generic hooks
 * (`[data-cross-selling]`, `.product-detail-cross-selling`). CMS “similar products” / theme-specific
 * sliders need extra selectors once their DOM is known.
 */
export class RecommendationsReachedStrategy implements PdpMeasurementStrategy {
  private disposeSection: (() => void) | null = null;

  attach(ctx: MeasurementStrategyContext): void {
    this.disposeSection = bindSectionReachedObserver({
      document: ctx.document,
      selectors: RECOMMENDATION_SECTION_SELECTORS,
      threshold: 0.1,
      onReached: () => {
        ctx.store.setRecommendationsReached();
      },
    });
  }

  dispose(): void {
    this.disposeSection?.();
    this.disposeSection = null;
  }
}
